import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const PauseIcon = ({
  width = 16,
  height = 16,
  stroke = '#52575C',
  strokeWidth = 1.5,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M4 2.66667H6.66667V13.3333H4V2.66667ZM9.33333 2.66667H12V13.3333H9.33333V2.66667Z"
    />
  </svg>
);
